import React from 'react';
import { packItems } from '../data/content';
import { Icon } from '../utils/icons';
export function WhatsInside() {
  return <section id="inside" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-201" data-mp="yupof507rb6y">
      <div className="mx-auto max-w-4xl" data-id="element-202" data-mp="kx11lrml5tz9">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-203" data-mp="kvzrbpde9bil">
          What&apos;s Inside the Pickleball Ready™ Pack?
        </h2>

        <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-204" data-mp="b54yu39k1fop">
          {packItems.map(item => <li key={item.title} className="grid grid-rows-[auto_auto_1fr] rounded-2xl bg-sand px-6 py-8 text-center" data-id="element-205" data-mp="fyzix7t2nwob">
              <span className="mx-auto inline-flex h-10 w-10 items-center justify-center rounded-full bg-white text-brand" data-id="element-206" data-mp="75mh1gd15kq3">
                <Icon name={item.icon} className="h-5 w-5" data-id="element-207" data-mp="3odq6782lytma" />
              </span>
              <h3 className="mt-4 font-display text-base font-bold text-ink" data-id="element-208" data-mp="3tbjdy5jk7voo">
                {item.title}
              </h3>
              <p className="mt-2 text-xs leading-relaxed text-ink/55" data-id="element-209" data-mp="3cw0i02n7dahr">
                {item.text}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}